import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SmartadminValidationModule } from '../../shared/forms/validation/smartadmin-validation.module';
import { PsI18nModule } from '../../pf.core/i18n/psi18n.module';
import { I18nModule } from '../../shared/i18n/i18n.module';
import { LoginComponent } from './login.component';
import { ModalModule } from 'ngx-bootstrap';
import { CookieModule } from 'ngx-cookie';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SmartadminValidationModule,
    I18nModule,
    RouterModule,
    PsI18nModule,
    ModalModule,
    CookieModule.forRoot()
  ],
  declarations: [LoginComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/login/login.module.ts